import React from "react";
import { Box, Typography, Button, IconButton, Alert } from "@mui/material";
import { Fullscreen, Close, Security } from "@mui/icons-material";

interface FullscreenPromptProps {
  onEnterFullscreen: () => void;
  onDismiss: () => void;
}

const FullscreenPrompt: React.FC<FullscreenPromptProps> = ({ onEnterFullscreen, onDismiss }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
      }}
    >
      <Alert
        severity="info"
        action={
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              startIcon={<Fullscreen />}
              onClick={onEnterFullscreen}
              variant="outlined"
            >
              Enter Fullscreen
            </Button>
            <IconButton size="small" color="inherit" onClick={onDismiss}>
              <Close />
            </IconButton>
          </Box>
        }
        icon={<Security />}
      >
        <Typography variant="body2" component="div">
          <strong>Security Mode:</strong> For enhanced security, please enter fullscreen mode. Use
          the button above or press <strong>Ctrl+F</strong>
        </Typography>
      </Alert>
    </Box>
  );
};

export default FullscreenPrompt;
